<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
     
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center" style="background-color: #51e0fe;">

            <div class="vx-col hidden lg:block lg:w-1/2" >
              <img src="@/assets/images/pages/login.jpg" alt="login" class="mx-auto w-full" style="max-height: 500px">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{ isAdminLogin ? '智慧溯源系统管理员登录' : '登录智慧溯源系统'}}</h4>
                  <p>中国二维码溯源中心</p>
                </div>
                <vs-tabs>
                  <vs-tab label="账号密码登录">
                    <login-jwt></login-jwt>
                  </vs-tab>
                  <vs-tab label="手机验证码登录">
                    <login-sms></login-sms>
                  </vs-tab>
                </vs-tabs>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from "./LoginJWT.vue"
import LoginSms from "./LoginSms.vue"

export default {
  components: {
    LoginJwt,
    LoginSms,
  },
  async mounted() {
    // if (this.isAdminLogin) {
    //   this.$s.mainLayoutType = 'vertical'
    //   this.$s.themePrimaryColor = '#ea5455'
    //   this.$vs.theme({ primary: '#ea5455' });
    // } else {
    //   this.$s.mainLayoutType = 'horizontal'
    //   this.$s.themePrimaryColor = '#28c76f'
    //   this.$vs.theme({ primary: '#28c76f' })
    // }
    if (await this.$s.auth.isLogin()) {
      this.$s.auth.loginSuccess(this.$s.auth.user, this)
    }
  },
  computed: {
    isAdminLogin() {
      return false
    }
  },
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
